import { render, staticRenderFns } from "./partners.vue?vue&type=template&id=40540f7f&scoped=true"
import script from "./partners.vue?vue&type=script&lang=js"
export * from "./partners.vue?vue&type=script&lang=js"
import style0 from "./partners.vue?vue&type=style&index=0&id=40540f7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40540f7f",
  null
  
)

export default component.exports